module.exports = __webpack_public_path__ + "static/media/landing-ico-2.4916a436.svg";